<template>
  <div class="contens">
    <!-- 典当信用查询 -->
    <!-- <div>
        原来的数据：
    {{datas}}
    </div>
    <div>
        定位的数据：
    {{newData}}
    </div> -->

    <h3>企业端数据联通测试</h3>
    <h3>请求当前票号：{{ newData }}</h3>
    <div>
      <el-button type="primary" @click="getData">测试请求企业端票号</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Printing",
  data() {
    return {
      // datas:["上海","北京","深圳","南京","苏州"],
      newData: {},
    };
  },
  methods: {
    getData() {
      this.axios
        .post("/getQydData/api/corp/accept/queryCode", {
          sign:
            "MEMCH1xWjwlTTJBZGxqK/tVPfBfnhqhboyuASRcRyYatpD8CIAK3jbzXywElGGX7W8RxLjDFAz/t1EAIkBBET9wvFpd3",
          packet:
            "MIIBSQIgplh6TuTy4/X4PC1agyDDOPdF5IDyXpy17U+GKfBmZnICII5blwNrC3keU4FZGBD9N+PZ6Fq/r0J9bXdmWyAIxqFOBCAJNz3lOdnouCRr3vakhYTkwmn7Y8EPuj43hVCorvj8rgSB4Pta3nLQ/GYifxkbd0V9I9AgMvPBDJUsvgoprsg0ikA48qr4BBY2w5W8qhWJVZmwo+6jQ8vWEwg66M44wQN+S0hbU/PMFVvuP38tkSmQoyQtp793toiRyQAk6uNVDWbfL4oHojYHvVzRRa7MjaOpZtTPRjzVAbOo3nHeo++IfgkihQSpSm1l2Y9Kmju0RC3pl+IHoFcc1FfotzosyHvG9nuLSsoztsPFBffFvYoihmeTa19Cgw6Jwzt+9MUVFqynya2cAhbIITNB9y/HXxOT6sbwraf3/oAW3O3ArUiHANdz",
        })
        .then((res) => {
          console.log(res);
          this.newData = res.data;
        });
    },
  },

  created() {
    // let arr = ["上海","北京","深圳","南京","苏州"]
    // arr[2] = "广州"
    // this.newData = arr
  },
};
</script>
